import React from 'react';
interface LogoTileProps {
  title: string;
  href: string;
  logoSrc: string;
  external?: boolean;
  badge?: string;
  onClick?: (e: React.MouseEvent) => void;
}
function LogoTile({
  title,
  href,
  logoSrc,
  external = false,
  badge,
  onClick
}: LogoTileProps) {
  return <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className="group relative bg-white rounded-lg border-2 border-gray-200 hover:border-orange hover:shadow-md transition-all duration-300 p-4 flex flex-col items-center justify-center min-h-[120px]" onClick={onClick ? e => {
    e.preventDefault();
    onClick(e);
  } : undefined} data-id="element-2608">
      {badge && <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-bold text-white bg-orange rounded" data-id="element-2609">
          {badge}
        </span>}
      <div className="w-full h-16 flex items-center justify-center mb-2" data-id="element-2610">
        <img src={logoSrc} alt={`${title} logo`} className="block max-h-16 max-w-full w-auto h-auto object-contain" data-id="element-2611" />
      </div>
      <h3 className="text-xs font-semibold text-navy text-center group-hover:text-orange transition-colors leading-tight" data-id="element-2612">
        {title}
      </h3>
    </a>;
}
export function FeaturedProductLinesSection() {
  const productLines = [{
    title: 'Used Machine Inventory',
    href: '59m7/used-machines.html',
    logoSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/1-Peak-Used-Machine-Sales.jpg'
  }, {
    title: 'Fast Wire EDM – Moly Wire',
    href: '/EDMNetworkFastWire.html',
    logoSrc: 'https://cdn.magicpatterns.com/uploads/3jKRGdDYYyuJjCRsZ6dRUg/fasstwire.png',
    badge: 'NEW'
  }, {
    title: 'Seibu America',
    href: '/SeibuWireEDM.html',
    logoSrc: 'https://cdn.magicpatterns.com/uploads/mwCcXhT84D9ARV8scnZFzp/seibu-america.png',
    badge: 'NEW'
  }, {
    title: 'EDM Network',
    href: '/EDMNetwork.html',
    logoSrc: 'https://cdn.magicpatterns.com/uploads/apJvfBStMi2YLnfZWoZHky/new_logo.png',
    badge: 'NEW'
  }, {
    title: 'Spinner',
    href: '/SpinnerMachineTools.html',
    logoSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS%20Resized/SPINNER.png'
  }, {
    title: 'Breton',
    href: '/BretonMachineTools.html',
    logoSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS%20Resized/Breton.png'
  }, {
    title: 'Bodor Laser',
    href: 'BodorLaserCutting.html',
    logoSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS%20Resized/Bodor%20Laser.png'
  }];
  return <section className="py-6 bg-gray-50 border-b border-gray-200" data-id="element-2613">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2614">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3" data-id="element-2615">
          {productLines.map((product, index) => <LogoTile key={index} title={product.title} href={product.href} logoSrc={product.logoSrc} badge={product.badge} data-id="element-2616" />)}
        </div>
      </div>
    </section>;
}